import { m } from '@aimfora/i18n'
import { createFileRoute } from '@tanstack/react-router'
import { OrganizationPage } from '~/components/admin/organization-page'
import { PageHeader } from '~/components/app-shell'

export const Route = createFileRoute('/_authed/_admin/admin/organizations/$orgId')({
  head: () => ({ meta: [{ title: `${m.admin_nav_organizations()} – ${m.app_name()}` }] }),
  component: OrganizationRoute,
})

function OrganizationRoute() {
  const { orgId } = Route.useParams()
  return (
    <>
      <PageHeader title={m.admin_nav_organizations()} />
      <OrganizationPage orgId={orgId} />
    </>
  )
}
